import { ListItemText, MenuItem } from '@mui/material';
import { GanttStripDto } from '@types';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { useSetUi } from '../../../contexts/UiContext';
import { ROUTE_REQUESTS } from '../../../routes';

export const StripMenuItemSeeRequestView = memo(function StripMenuItemSeeRequestView({
    slot,
}: {
    slot: GanttStripDto;
}) {
    const setHighlightedSlotId = useSetUi('highlightedSlotId');
    const navigate = useNavigate();
    const handleClick = () => {
        setHighlightedSlotId(slot.id || null);
        // TODO: Better solution?
        // Timeout because RequestPage depends on highlightedSlotId being non-null for initial render
        setTimeout(() => {
            navigate(ROUTE_REQUESTS);
        }, 50);
    };
    return (
        <MenuItem onClick={handleClick}>
            <ListItemText>
                <FormattedMessage id="strip.actions.seeRequestView" />
            </ListItemText>
        </MenuItem>
    );
});
